const HIGH_PRIORITY_NEIGHBORHOODS_OF_NY = [
  "Astoria",
  "Bayside",
  "Briarwood",
  "Corona",
  "Douglaston",
  "Flushing",
  "Glen Oaks",
  "Jamaica",
  "Jackson Heights",
  "Malba",
  "Maspeth",
  "Middle Village",
  "Far Rockaway",
  "Fresh Meadows",
  "Kew Gardens Hills",
  "Little Neck",
  "Long Island City",
  "Rockaway Beach",
  "Woodside",
  "Arverne",
  "Breezy Point",
  "Broad Channel",
  "College Point",
  "East Elmhurst",
  "Elmhurst",
  "Forest Hills",
  "Hollis",
  "Howard Beach",
  "Laurelton",
  "Neponsit",
  "Ozone Park",
  "Queens Village",
  "Rego Park",
  "Rosedale",
  "South Richmond Hill",
  "Sunnyside",
  "Whitestone"
], HIGH_PRIORITY_BOROUGHS_OF_NY = [
  "Brooklyn",
  "Queens",
  "The Bronx",
  "Staten Island",
  "Manhattan"
];
export {
  HIGH_PRIORITY_BOROUGHS_OF_NY,
  HIGH_PRIORITY_NEIGHBORHOODS_OF_NY
};
//# sourceMappingURL=constants.js.map
